module.exports = __webpack_public_path__ + "static-v-shop/1792141392954/img/banner-desktop.c46aa3b3.png";